import { render, staticRenderFns } from "./shenbaoAdd.vue?vue&type=template&id=0e1c0059&scoped=true&"
import script from "./shenbaoAdd.vue?vue&type=script&lang=js&"
export * from "./shenbaoAdd.vue?vue&type=script&lang=js&"
import style0 from "./shenbaoAdd.vue?vue&type=style&index=0&id=0e1c0059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c0059",
  null
  
)

export default component.exports